import { useRef, useState } from "react";

/**
 * Promise-based confirm, a styled drop-in for window.confirm().
 *   const { confirm, modalProps } = useConfirm();
 *   const ok = await confirm({ title, message, confirmLabel });
 *   ...
 *   <ConfirmModal {...modalProps} />
 */
export default function useConfirm() {
  const [state, setState] = useState({ open: false });
  const resolver = useRef(null);

  const confirm = (opts = {}) =>
    new Promise((resolve) => {
      resolver.current = resolve;
      setState({ open: true, ...opts });
    });

  const close = (result) => {
    setState((s) => ({ ...s, open: false }));
    resolver.current?.(result);
    resolver.current = null;
  };

  const modalProps = {
    ...state,
    onConfirm: () => close(true),
    onCancel: () => close(false),
  };

  return { confirm, modalProps };
}
